export const BadContractState = "BAD_CONTRACT_STATE";
export const BadRequestState = "BAD_REQUEST_STATE";
export const ContractValidityExpired = "CONTRACT_VALIDITY_EXPIRED";
export const CompanyDeathCannotContinue = "COMPANY_DEATH_CANNOT_CONTINUE";
